'use strict';

var _ = require('lodash');
var LevelSecondaryCriteriaController = function LevelSecondaryCriteriaController($scope, elementService, strategyConstants) {
  $scope.elementService = elementService;
  function createFirstGroup() {
    if (!$scope.strategy.groups || !$scope.strategy.groups.length) {
      $scope.strategy.groups = [elementService.createGroup()];
    }
  }
  createFirstGroup();
  $scope.resetIfEmpty = function () {
    if (isCustomStrategy()) {
      createFirstGroup();
    }
  };
  function isCustomStrategy() {
    return $scope.strategy.basis === strategyConstants.StrategyType.CUSTOM;
  }
  function isCollectionStateDefault(collection) {
    return collection.length === 1 && collection[0].isEmpty();
  }
  function add(newElement, collectionName) {
    var selectedRowType = elementService.getSelectedRowType();
    var selectedGroup = elementService.getSelectedGroup();
    var collection = selectedGroup[collectionName];
    if (selectedRowType === collectionName) {
      var selectedElement = elementService.getSelectedElement();
      var insertionIndex = collection.indexOf(selectedElement);
      if (insertionIndex !== -1) {
        if (selectedElement.isEmpty()) {
          collection[insertionIndex] = newElement;
        } else {
          collection.splice(insertionIndex + 1, 0, newElement);
        }
      } else {
        if (isCollectionStateDefault(collection)) {
          collection[0] = newElement;
        } else {
          collection.push(newElement);
        }
      }
    } else {
      if (isCollectionStateDefault(collection)) {
        collection[0] = newElement;
      } else {
        collection.push(newElement);
      }
    }
    elementService.selectRow(selectedGroup, newElement, collection, selectedRowType);
  }
  $scope.conditionsAccordionSelect = function (conditionCategory, conditionCriteria) {
    var newConditionParams = {
      quantifier: 'AND',
      category: conditionCategory.categoryName,
      criterion: conditionCriteria.criteriaName,
      field: conditionCriteria.field,
      operator: conditionCriteria.operators[0].operator,
      precision: conditionCriteria.operators[0].precision,
      isFieldValueRequired: !_.isUndefined(conditionCategory.isFieldValueRequired) ? conditionCategory.isFieldValueRequired : true
    };
    var newCondition = elementService.createCondition(newConditionParams);
    add(newCondition, 'conditions');
  };
  $scope.actionsAccordionSelect = function (actionCategory, action) {
    var newActionParam = {
      category: actionCategory.categoryName,
      criterion: action.criteriaName,
      action: action.actions[0].option,
      argsNo: action.actions[0].argsNo,
      field: action.field,
      criteriaType: action.criteriaType ? action.criteriaType.fieldValue : null
    };
    var newAction = elementService.createAction(newActionParam);
    add(newAction, 'actions');
  };
  $scope.isGroupHighlighted = function (group) {
    return elementService.isGroupSelected(group);
  };
  $scope.isRowSelected = function () {
    return elementService.isRowSelected();
  };
  $scope.isGroupSelected = function (group) {
    return $scope.isGroupHighlighted(group) && !$scope.isRowSelected();
  };
  $scope.selectStrategyGroup = function (strategyGroup) {
    // if (strategyGroup) {
    //     $scope.strategyWithSelectedGroup.groups = [strategyGroup];
    // }
    $scope.onSelect();
    elementService.selectGroup(strategyGroup, $scope.strategy.groups);
  };
  $scope.selectStrategyCondition = function () {
    $scope.onSelect();
  };
  $scope.resetGroupsAfterLevelChange = function (newLevel, oldLevel) {
    if (newLevel !== oldLevel) {
      $scope.strategy.groups = null;
      createFirstGroup();
    }
  };
  $scope.isStatementBoxVisible = function (group) {
    return group.isVisible && !$scope.isStatementEmpty(group);
  };
  $scope.toggleStatementBox = function (strategyGroup) {
    if (!$scope.isStatementEmpty($scope.strategyGroup)) {
      strategyGroup.isVisible = !strategyGroup.isVisible;
    } else {
      strategyGroup.isVisible = false;
    }
  };
  $scope.resetGroupAfterFlowTypeChange = function () {
    $scope.strategy.groups = null;
    createFirstGroup();
  };
};
LevelSecondaryCriteriaController.$inject = ['$scope', 'StrategyElementService', 'StrategyConstants'];
module.exports = LevelSecondaryCriteriaController;